<template>
  <PageLayout>
    <h1>{{ i18n.notFound }}</h1>
  </PageLayout>
</template>

<script setup>
import PageLayout from "@/components/PageLayout.vue";
import {i18n} from "@/services/support/i18n";
</script>
